<script>
import { layoutMethods } from '@/state/helpers';
import i18n from '../i18n';
import { msalMixin } from 'vue-msal';
import Repositories from '@/repositories';
const UsersRepository = Repositories.get('users');
/**
 * Nav-bar Component
 */
export default {
  mixins: [msalMixin],
  data() {
    return {
      languages: [
        {
          flag: require('@/assets/images/flags/us.jpg'),
          language: 'en',
          title: 'English',
        },
        {
          flag: require('@/assets/images/flags/french.jpg'),
          language: 'fr',
          title: 'Français',
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      notifInterval: null,
      showNewFeatureModal: false,
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.showNewFeatureModal =
      this.$store.state.user.config.currentAppVersion !=
      this.$store.state.user.config.lastSeenVersion
        ? true
        : false;
  },
  computed: {
    currentAccount() {
      return this.$msal.currentAccount;
    },
    portalUrl() {
      return process.env.VUE_APP_PORTAL_URL;
    },
    documentationUrl() {
      if (this.lan == 'fr') {
        return process.env.VUE_APP_DOCUMENTATION_SITE_FR;
      }
      return process.env.VUE_APP_DOCUMENTATION_SITE_EN;
    },
  },
  methods: {
    ...layoutMethods,
    toggleMenu() {
      this.toggleMenuCondensed();

      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle('fullscreen-enable');
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      this.$store.dispatch('user/updateUserLanguage', locale);

      //TO_DELETE localStorage.setItem("inventaireLocale", locale);
    },
    logoutUser() {
      this.$msal.logout();
    },
    userReadNewFeatures() {
      //set user last seen build number
      UsersRepository.customREST
        .setUserLastSeenBuildNumber(this.$store.state.user.config.idPublic)
        .then(() => {
          this.$store.dispatch('user/updateUserAppVersion');
          this.showNewFeatureModal = false;
        });
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex logo-section" style="align-items: center">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="@/assets/images/icone_wc_blue_waves.png"
                alt
                height="22"
              />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/logo_wc_blue_waves.png"
                alt
                height="17"
              />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm" style="position: relative; left: -5px">
              <img
                src="@/assets/images/icone_wc_blue_waves.png"
                alt
                width="39"
                height="22"
              />
            </span>
            <span class="logo-lg" style="position: relative; left: -22px">
              <img
                src="@/assets/images/logo_wc_blue_waves.png"
                alt
                height="25"
              />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item toggle-menu-btn"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <img
          v-if="lan === 'en'"
          height="37px"
          style="object-fit: contain"
          src="@/assets/images/logo_text_en.png"
          alt="logo"
        />
        <img
          v-else
          height="37px"
          style="object-fit: contain"
          src="@/assets/images/logo_text_fr.png"
          alt="logo"
        />
      </div>

      <div class="d-flex">
        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <div class="dropdown d-lg-inline-block ms-1">
          <a
            :href="portalUrl"
            target="_blank"
            class="btn header-item noti-icon"
          >
            <i class="bx bx-customize" style="margin-top: 8px"></i>
          </a>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown
          v-if="currentAccount != null"
          right
          variant="black"
          toggle-class="header-item"
        >
          <template v-slot:button-content>
            <div style="display: flex; align-items: center">
              <div
                class="rounded-circle header-profile-user"
                style="
                  height: 33px;
                  width: 33px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: #f3a821;
                "
              >
                <span
                  style="
                    font-weight: 600;
                    color: white;
                    font-size: 1.1em;
                    vertical-align: center;
                  "
                >
                  {{ currentAccount.name.charAt(0) }}
                </span>
              </div>
              <span class="d-none d-xl-inline-block ml-1">
                {{ currentAccount.name }}
              </span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
          </template>
          <b-dropdown-item :href="documentationUrl" target="_blank">
            <i
              style="position: relative; top: -1px"
              class="bx bx-notepad font-size-16 align-middle mr-1"
            ></i>
            {{ $t('general.releaseNotes') }}
          </b-dropdown-item>
          <a
            @click="logoutUser"
            class="dropdown-item text-danger"
            style="cursor: pointer"
          >
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t('navbar.logout') }}
          </a>
        </b-dropdown>
      </div>
    </div>
    <b-modal v-model="showNewFeatureModal" no-close-on-backdrop>
      <p class="mb-2">
        {{ $t('general.' + 'newFeaturesText') }}
      </p>
      <b-button variant="primary" :href="documentationUrl" target="_blank">{{
        $t('general.seeNewFeatures')
      }}</b-button>
      <template v-slot:modal-header>
        <h5 class="modal-title mr-3">
          {{ $t('general.' + 'newFeaturesTitle') }}
        </h5>
        <button
          @click="showNewFeatureModal = false"
          type="button"
          class="close"
          aria-label="Close"
        >
          ×
        </button>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="success" @click="userReadNewFeatures">{{
          $t('general.' + 'ihaveread')
        }}</b-button>
      </template>
    </b-modal>
  </header>
</template>
<style scoped>
.notification-unread {
  background-color: #f8f8fb !important;
}
</style>